import { ReactNode, useContext, useState } from "react";
import CursorProvider, { CursorState } from "../../../providers/CursorProvider";
import { CursorComponent } from "../CursorComponent";

interface PlzenbP
{
    offState : ReactNode;
    onState : ReactNode;
    onEnable ?: () => void;
    stdOnClick ?: () => void;
    className ?: string;
    style ?: React.CSSProperties;
}

export function Plzen (props: PlzenbP) {
    const cursor = useContext(CursorProvider.context);
    const [enb, setEnb] = useState<boolean>();
    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};

    const hasStyleOrClass = props.className !== undefined || props.style !== undefined;
    const onState = hasStyleOrClass ? <div className={className} style={style}>{ props.onState }</div> : props.onState;

    return enb 
    ? onState 
    : <CursorComponent className={className} style={style} cursor={CursorState.PLZ} onClick={() => {
        if (!cursor.plzchg)
        {
            if (enb && props.stdOnClick !== undefined)
                props.stdOnClick();
            return;
        }
            
        setEnb(true);
        cursor.setPlzchg(false);

        if (props.onEnable !== undefined)
            props.onEnable();
    }} stdOnClick={() => {
        if (enb && props.stdOnClick !== undefined)
            props.stdOnClick();
    }}>
        { props.offState }
    </CursorComponent>
}